import { api } from './api';

const BASE_ENDPOINT = 'reports/portfolio-summary';

/**
 * GET /api/reports/portfolio-summary
 * Fetches consolidated portfolio summary report with asset group allocations
 * 
 * @returns {Promise<Object>} Portfolio summary data with asset groups and grand totals
 * 
 * Response structure:
 * {
 *   asset_groups: [
 *     {
 *       group_name: "Direct Equity",
 *       items: [
 *         {
 *           asset_name: "Investment Account",
 *           invested_amount: 2000000.00,
 *           current_value: 2150000.00,
 *           gain_loss: 150000.00,
 *           gain_loss_percent: 7.50
 *         }
 *       ]
 *     }
 *   ],
 *   grand_total: {
 *     invested_amount: 18100000.00,
 *     current_value: 20387000.00,
 *     gain_loss: 2287000.00,
 *     gain_loss_percent: 12.64
 *   }
 * }
 */
export const getPortfolioSummaryReport = async () => {
  try {
    const res = await api.get(BASE_ENDPOINT);
    return res.data;
  } catch (error) {
    console.error('Error fetching portfolio summary report:', error);
    throw error;
  }
};

/**
 * GET /api/reports/portfolio-summary/pdf
 * Downloads portfolio summary report as PDF
 * 
 * @returns {Promise<Blob>} PDF file blob
 */
export const downloadPortfolioSummaryPDF = async () => {
  try {
    const res = await api.get(`${BASE_ENDPOINT}/pdf`, {
      responseType: 'blob',
    });
    return res.data;
  } catch (error) {
    console.error('Error downloading portfolio summary PDF:', error);
    throw error;
  }
};

export default {
  getPortfolioSummaryReport,
  downloadPortfolioSummaryPDF,
};
